// @ts-check
import api from 'utils/api';
import { getStore } from 'shared/stash';

const REQUESTING_COST_ESTIMATE = 'REQUESTING_COST_ESTIMATE';
const RECEIVE_COST_ESTIMATE = 'RECEIVE_COST_ESTIMATE';
const RESET_COST_ESTIMATE = 'RESET_COST_ESTIMATE';

export { REQUESTING_COST_ESTIMATE, RECEIVE_COST_ESTIMATE, RESET_COST_ESTIMATE };

const actions = {
  requestingCostEstimate() {
    return getStore().dispatch({ type: REQUESTING_COST_ESTIMATE });
  },

  receiveCostEstimate(payload) {
    return getStore().dispatch({ type: RECEIVE_COST_ESTIMATE, payload });
  },

  resetCostEstimate() {
    return getStore().dispatch({ type: RESET_COST_ESTIMATE });
  },

  createCostEstimate(params) {
    actions.requestingCostEstimate();

    return api.post('/agent_portal/api/cost_estimates', params).then(response => {
      actions.receiveCostEstimate({ costEstimate: response.data });
    });
  },
};

export default actions;
